/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 6a9f8221ded1412e0c73c8042598a49b6b82d13d493d76dc016d809401594a6e
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './Overlay.style'

type OverlayOwnProps = {
  className?: string
  children?: React.ReactNode
  padding?: 'none' | 'small' | 'large'
}

export type OverlayProps = OverlayOwnProps & Omit<ComponentProps<'div'>, keyof OverlayOwnProps>

function Overlay(props: OverlayProps): ReactElement {
  const {
    children,
    className = '',
    padding = 'none',
    ...rest
  } = props

  return (
    <div
      className={cn('Overlay', className, padding)}
      css={style}
      {...rest}
      role='presentation'
    >
      {children}
    </div>
  )
}

export default Overlay
